/**
 * 017: composes `ErrorSurface` (packages/theme/src/domain/error-surface.tsx), built on rizzui's
 * `Alert`. The vendor template ships no generic crash/error screen anywhere under
 * vendor/isomorphic/apps/isomorphic/src — confirmed by search, so there is no template file to
 * name here beyond the rizzui primitive `ErrorSurface` itself composes.
 *
 * Only the data, columns and labels are ours. The screen-to-template mapping is
 * specs/017-isomorphic-theme-only/contracts/screen-map.md.
 */
import { Link, useNavigate, useRouteError } from "react-router-dom";
import { Button } from "rizzui";
import { ErrorSurface } from "@steelyard/theme";
import { ApiError } from "../lib/api";
import NotFound from "./not-found";

/**
 * Ported from apps/admin/app/error.tsx + (app)/error.tsx + (auth)/error.tsx. React Router's
 * `errorElement` replaces Next's per-segment error boundary — one component, attached at
 * whichever route level needs it, catches what its subtree's loaders/actions/render throw.
 */
export default function AppError() {
  const error = useRouteError();
  const navigate = useNavigate();
  // A screen whose own record does not exist (a mistyped id, or a word like /credit-notes/new caught
  // by an `:id` segment) is an address nothing answers, not a failure to retry.
  if (error instanceof ApiError && error.status === 404) return <NotFound />;

  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col justify-center gap-4 px-4 py-10">
      <ErrorSurface error={error} action="start this screen">
        <div className="flex gap-2">
          <Button variant="outline" size="sm" type="button" onClick={() => navigate(0)}>
            Try again
          </Button>
          
            <Link to="/"><Button as="span" variant="text" size="sm">Back to dashboard</Button></Link>
        </div>
      </ErrorSurface>
    </div>
  );
}
